import { QueryHookOptions } from '@apollo/client';
import {
  ValueSetEntitlementItem,
  ValueSetEntitlementName,
  ValueSetEntitlementValueTypes,
} from '@jupiterone/entitlement-types';
import gql from 'graphql-tag';
import { createUseQueryHook } from '../apollo/createUseQueryHook';

export const CheckValueSetEntitlementAccessQuery = gql`
  query checkValueSetEntitlementAccess($valueSetEntitlementName: String!) {
    checkValueSetEntitlementAccess(
      valueSetEntitlementName: $valueSetEntitlementName
    ) {
      items {
        canAccess
        displayName
        value
      }
    }
  }
`;

type Variables = {
  valueSetEntitlementName: string;
};

type Response<V extends ValueSetEntitlementName> = {
  checkValueSetEntitlementAccess: {
    items: ValueSetEntitlementItem<ValueSetEntitlementValueTypes[V]>[];
  };
};

const createUseValueSetEntitlements = <V extends ValueSetEntitlementName>(
  valueSetEntitlementName: ValueSetEntitlementName
) => (
  options?: Omit<QueryHookOptions<Response<V>, Variables>, 'variables'>
) => {
  const useQuery = createUseQueryHook<Response<V>, Variables>(
    CheckValueSetEntitlementAccessQuery
  );

  return useQuery({
    variables: {
      valueSetEntitlementName,
    },
    ...options,
  });
};

export const useAlertsDigestFrequencyValueSetEntitlements = createUseValueSetEntitlements<ValueSetEntitlementName.ALERTS_DIGEST_FREQUENCY>(
  ValueSetEntitlementName.ALERTS_DIGEST_FREQUENCY
);

export const useAlertsPollingIntervalValueSetEntitlements = createUseValueSetEntitlements<ValueSetEntitlementName.ALERTS_POLLING_INTERVAL>(
  ValueSetEntitlementName.ALERTS_POLLING_INTERVAL
);

export const useIntegrationsPollingIntervalValueSetEntitlements = createUseValueSetEntitlements<ValueSetEntitlementName.INTEGRATIONS_POLLING_INTERVAL>(
  ValueSetEntitlementName.INTEGRATIONS_POLLING_INTERVAL
);

export const useSupportSLAValueSetEntitlements = createUseValueSetEntitlements<ValueSetEntitlementName.SUPPORT_SLA>(
  ValueSetEntitlementName.SUPPORT_SLA
);

export const useSupportTypeValueSetEntitlements = createUseValueSetEntitlements<ValueSetEntitlementName.SUPPORT_TYPE>(
  ValueSetEntitlementName.SUPPORT_TYPE
);

export const useCurrentOEMBrandingEntitlements = createUseValueSetEntitlements<ValueSetEntitlementName.CURRENT_OEM_BRANDING>(
  ValueSetEntitlementName.CURRENT_OEM_BRANDING
);
